import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';

import { DropdownFilter } from '../../Planner/Filters/DropdownFilter';
import { ExternalProvider } from './ExternalProviderContext';
import TeamMappingContent from './TeamMapping/TeamMappingContent';
import RequestLogsContent from './ProviderRequest/RequestLogsContent';
import ClinicianMappingContent from './ClinicianUsernameMapping/ClinicianMappingContent';
import RequestLogsSearchFilters from './ProviderRequest/RequestLogsSearchFilters';
import ClinicianMappingFilters from './ClinicianUsernameMapping/ClinicianMappingFilters';
import OutcomeCodesPage from './OutcomeCodes/OutcomeCodesPage';
import { useExternalProviderTypeForTenant } from '../../../actions/areas/admin/fetchHooks/fetchExternalProvider';
import { ExternalProviderType, ExternalProviderOptions } from './../../../enums';
import globals from './../../../globals/communityGlobals';

const locale = globals.getArea('externalProvider');

const epTypeOptions = [ExternalProviderOptions[0]];
const teamOptions = [
  { id: 0, name: 'All Teams' },
  { id: 1, name: 'Mapped Teams' },
  { id: 2, name: 'Not Mapped Teams' },
];

export default function ExternalProviderPage() {
  const [state, setState] = useState({
    epType: epTypeOptions[0],
    mappingType: 0,
    requestStatus: 0,
  });
  const [cliniciansBySurname, setCliniciansBySurname] = useState('');

  const { data, isDataLoading } = useExternalProviderTypeForTenant(false);

  if (!isDataLoading) {
    if (data.externalProviderType !== ExternalProviderType.Rio && !epTypeOptions.find(x => x.key === 'requestLogs')) {
      epTypeOptions.push(ExternalProviderOptions.find(epo => epo.key === 'requestLogs'));
    }
    if (
      data.externalProviderType === ExternalProviderType.SystmOne &&
      !epTypeOptions.find(x => x.key === 'clinicianUsernameMapping')
    ) {
      epTypeOptions.push(ExternalProviderOptions[epTypeOptions.length]);
    }
    if (data.externalProviderType === ExternalProviderType.Rio && !epTypeOptions.find(x => x.key === 'outcomeCodes')) {
      epTypeOptions.push(ExternalProviderOptions.find(epo => epo.key === 'outcomeCodes'));
    }
  }

  const teamMappingFilter = () => {
    return (
      <React.Fragment>
        <Box p={1} width={110} textAlign="end">
          <span>{locale.getMsg('providerTeams')}</span>
        </Box>
        <Box p={1} width={200}>
          <DropdownFilter
            data={teamOptions}
            defaultValue={[teamOptions[0].id]}
            filterKey={'type'}
            filterValue={state.mappingType}
            onChange={(name, value) => setState({ ...state, mappingType: value })}
          />
        </Box>
      </React.Fragment>
    );
  };

  const content = {
    teamMapping: <TeamMappingContent mappingType={state.mappingType} />,
    requestLogs: <RequestLogsContent />,
    clinicianUsernameMapping: <ClinicianMappingContent cliniciansBySurname={cliniciansBySurname} />,
    outcomeCodes: <OutcomeCodesPage />,
  };

  const setEpTypeFilter = epType => {
    switch (epType.key) {
      case 'requestLogs':
        return <RequestLogsSearchFilters />;
      case 'clinicianUsernameMapping':
        return <ClinicianMappingFilters setCliniciansBySurname={setCliniciansBySurname} />;
      case 'outcomeCodes':
        return <span />;
      default:
        return teamMappingFilter();
    }
  };

  const setEpTypeContent = epType => {
    return content[epType.key];
  };

  return (
    <ExternalProvider>
      <React.Fragment>
        <section className="slick-page-header-section">
          <Box className="filter-section" display="flex" flexWrap="nowrap" p={0} justifyContent="flex-start" px={1}>
            <Box p={1}>
              <FilterListIcon />
            </Box>
            <Box p={1} width={60} textAlign="end">
              <span>Configure</span>
            </Box>
            <Box p={1} width={200}>
              <DropdownFilter
                data={epTypeOptions}
                defaultValue={[epTypeOptions[0].id]}
                filterKey={'type'}
                filterValue={state.epType.id}
                onChange={(name, value) => setState({ ...state, epType: ExternalProviderOptions[value] })}
              />
            </Box>
            {setEpTypeFilter(state.epType)}
          </Box>
        </section>
        {setEpTypeContent(state.epType)}
      </React.Fragment>
    </ExternalProvider>
  );
}
